import type { Content, TableLayout } from 'pdfmake/interfaces';
import type { ViewBlock } from '@/data/schemas';
import { cm, pdfColors, tableLayouts } from '../../theme.pdf';
import { BLOCK_SPACING } from '../layout';

type ChecklistBlock = Extract<ViewBlock, { type: 'checklist' }>;

export function renderChecklistBlock(block: ChecklistBlock): Content {
  return {
    table: {
      widths: [cm(0.6), '*'],
      dontBreakRows: true,
      body: block.items.map((item) => {
        const symbol = item.checked === true ? '☑' : item.checked === false ? '☐' : '-';

        return [
          {
            text: symbol,
            style: 'checkbox',
            alignment: 'center',
            fillColor: item.highlight ? pdfColors.yellow : undefined,
          },
          {
            text: item.label,
            style: 'checkboxLabel',
            fillColor: item.highlight ? pdfColors.yellow : undefined,
          },
        ];
      }),
    },
    layout: tableLayouts.noBorders as TableLayout,
    margin: [0, 0, 0, BLOCK_SPACING],
  };
}
